import {t} from "@lingui/core/macro";

import {BodyText} from "@khanacademy/wonder-blocks-typography";

/**
 * A component that displays the standard notice about Khanmigo chat retention.
 * Informs users that chats are kept for up to a year, while flagged chats
 * may be kept for up to two years.
 */
export function ChatRetentionNotice(): React.ReactElement {
    return (
        <BodyText>
            {t`Khanmigo chats are kept for up to one year, then may be deleted.`}
        </BodyText>
    );
}
